export const downloadsEnum = {
    SMART_PREDICT: 1,
    MEDICAL: 2,
    PATIENT: 3
}